import axios from "axios";

const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

const BACKEND = isLocalhost
  ? "http://127.0.0.1:8000"
  : process.env.REACT_APP_BACKEND_URL ||
    "https://ice-cream-paradise.onrender.com";

export const API_BASE = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API_BASE,
});

// =========================================================
// AUTH TOKEN HANDLING
// =========================================================
//
// IMPORTANT:
// Kitchen 1 and Kitchen 2 use sessionStorage.
// This keeps their login separate in different tabs.
//
// Delivery uses its own delivery token.
// Admin uses its own admin token.
//
// We select the token based on the current page.
// This prevents a kitchen token from being accidentally
// used on the Delivery Panel.
// =========================================================

api.interceptors.request.use(
  (config) => {
    const path = window.location.pathname;

    let token = "";

    // -----------------------------------------------------
    // KITCHEN PANEL
    // -----------------------------------------------------

    if (path.startsWith("/kitchen")) {
      token =
        sessionStorage.getItem("icp_kitchen_token") || "";
    }

    // -----------------------------------------------------
    // DELIVERY PANEL
    // -----------------------------------------------------

    else if (path.startsWith("/delivery")) {
      token =
        sessionStorage.getItem("icp_delivery_token") ||
        localStorage.getItem("icp_delivery_token") ||
        "";
    }

    // -----------------------------------------------------
    // ADMIN PANEL
    // -----------------------------------------------------

    else if (path.startsWith("/admin")) {
      token =
        localStorage.getItem("icp_admin_token") || "";
    }

    // -----------------------------------------------------
    // OTHER STAFF/API REQUESTS
    // -----------------------------------------------------

    else {
      // Prefer kitchen session token if this request
      // originated from a kitchen page.
      token =
        sessionStorage.getItem("icp_kitchen_token") ||
        sessionStorage.getItem("icp_delivery_token") ||
        localStorage.getItem("icp_delivery_token") ||
        localStorage.getItem("icp_admin_token") ||
        "";
    }

    // -----------------------------------------------------
    // ATTACH AUTHORIZATION HEADER
    // -----------------------------------------------------

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;